import React, { useRef, useState, useEffect } from "react";
import emailjs from "emailjs-com";
import toast from "react-hot-toast";

const DonationForm = ({ onSuccess }) => {
  const form = useRef();

  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    user_email: "",
    pan: "",
  });
  const [isValid, setIsValid] = useState(false);

  // ✅ Validation logic
  useEffect(() => {
    const phoneValid = /^[0-9]{10}$/.test(formData.user_phone);
    const panValid = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan);
    const allFilled = Object.values(formData).every((v) => v.trim() !== "");
    setIsValid(phoneValid && panValid && allFilled);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_1xi9xmq", "donation_submission", form.current, "jSyfNwEcEwHQJyZ1B")
      .then(() => {
        emailjs.send(
          "service_1xi9xmq",
          "donation_auto_reply",
          {
            name: form.current.user_name.value,
            email: form.current.user_email.value,
          },
          "jSyfNwEcEwHQJyZ1B"
        );
        
        toast.success("Form submitted successfully! Showing QR code...");
        onSuccess?.();
        form.current.reset();
      })
      .catch((error) => {
        toast.error("Error sending form. Please try again.");
        console.error(error);
      });
  };

  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      className="bg-white p-8 rounded-2xl shadow-md border border-green-200 space-y-5"
    >
      <div className="grid gap-5">
        <input
          type="text"
          name="user_name"
          placeholder="Full Name"
          value={formData.user_name}
          onChange={handleChange}
          required
          className="w-full border border-green-300 px-4 py-3 rounded-md"
        />
        <input
          type="text"
          name="user_phone"
          placeholder="Phone Number (10 digits)"
          value={formData.user_phone}
          onChange={handleChange}
          required
          className="w-full border border-green-300 px-4 py-3 rounded-md"
        />
        <input
          type="email"
          name="user_email"
          placeholder="Email ID"
          value={formData.user_email}
          onChange={handleChange}
          required
          className="w-full border border-green-300 px-4 py-3 rounded-md"
        />
        <input
          type="text"
          name="pan"
          placeholder="PAN Number (e.g., ABCDE1234F)"
          value={formData.pan}
          onChange={handleChange}
          required
          className="w-full border border-green-300 px-4 py-3 rounded-md"
        />
      </div>

      <button
        type="submit"
        disabled={!isValid}
        className={`w-full py-3 rounded-md font-semibold transition ${
          isValid ? "bg-green-700 hover:bg-green-800 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"
        }`}
      >
        Submit & View QR
      </button>
    </form>
  );
};

export default DonationForm;
